const DEFAULT_MIN_CHARS = 3;
const MIN_BY_LOCALE: { [key: string]: number } = {
  'zh-TW': 1,
  'ko-KR': 1,
  'ja-JP': 2,
};

export const getMinRequiredChars = (locale: string) => MIN_BY_LOCALE[locale] || DEFAULT_MIN_CHARS;
